$(document).ready(function() {
  $('.cv_custom_collection_swatch').on('click', function() {
    var div_id = $(this).attr('data-variant');
    $.ajax({
      url:'/cart/add',
      type:'POST',
      dataType: 'HTML',
      data: {
        id: div_id,
        quantity : 1,
      },
      success: function(response){
        window.location.href="/cart";  
      }  
    });
  });
  $('.cv_custom_fan_slider').slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 3
        }
      }
    ]
  });

  $('.cv_latest_rl_sldd').slick({
    dots: false,
    infinite: true,
    arrows:true,
    slidesToShow: 2,
    slidesToScroll: 1,
  });

  $('.cv_custom_recom_slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { 
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows:true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows:true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows:true
        }
      }
    ]
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,
    centerMode: true,
    focusOnSelect: true 
  });
  $('.cv_custom_thumbnail_slider').slick({
    dots: true,
    infinite: false, 
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      { 
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }); 
 
  $('.cv_best_seller_Slide').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
  });
  setTimeout(function(){
    $('.cv_custom_Active_Faq_head_1').addClass('active');
    $('.cv_custom_Active_Faq_head_2').addClass('active');
    $('.cv_custom_product_acco_content_2').css('display','block');
    $('.cv-panel').css('max-height','1275px');

  }, 10);
  $(".cv_custom_product_set > a").on("click", function(e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
      .siblings(".cv_custom_product_acco_content")
      .slideUp(200);
      $(".cv_custom_product_set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    } else {
      $(".cv_custom_product_set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
      $(".cv_custom_product_set > a").removeClass("active");
      $(this).addClass("active");
      $(".cv_custom_product_acco_content").slideUp(200);
      $(this)
      .siblings(".cv_custom_product_acco_content")
      .slideDown(200);
    }
  });
});
$(document).on('click','.Cv_bottom_link_fan',function(e){
  e.preventDefault();

  $('.cv_Custom_fan_page_outer_image_upload').toggle();
});

setTimeout(function(){
  var controls =
      [  
        'play',
        'progress'
      ];
  const players = Plyr.setup('.js-player', { controls });
  $('.cv_custom_custom_content_description').show();
  var cv_copie_fi = $('.cv__icon_download').attr('data-img-album');
  $(".cv_custom_album_play_contents_inner_part .plyr__controls .plyr__controls__item:first-child").css("background-image", "url(" + cv_copie_fi + ")");
  $('.cv_custom_custom_content_description_1').insertAfter('.cv_custom_album_play_contents_inner_part_1 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_2').insertAfter('.cv_custom_album_play_contents_inner_part_2 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_3').insertAfter('.cv_custom_album_play_contents_inner_part_3 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_4').insertAfter('.cv_custom_album_play_contents_inner_part_4 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_5').insertAfter('.cv_custom_album_play_contents_inner_part_5 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_6').insertAfter('.cv_custom_album_play_contents_inner_part_6 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_7').insertAfter('.cv_custom_album_play_contents_inner_part_7 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_8').insertAfter('.cv_custom_album_play_contents_inner_part_8 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_9').insertAfter('.cv_custom_album_play_contents_inner_part_9 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_10').insertAfter('.cv_custom_album_play_contents_inner_part_10 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_11').insertAfter('.cv_custom_album_play_contents_inner_part_11 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_12').insertAfter('.cv_custom_album_play_contents_inner_part_12 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_13').insertAfter('.cv_custom_album_play_contents_inner_part_13 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_14').insertAfter('.cv_custom_album_play_contents_inner_part_14 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_15').insertAfter('.cv_custom_album_play_contents_inner_part_15 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_16').insertAfter('.cv_custom_album_play_contents_inner_part_16 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_17').insertAfter('.cv_custom_album_play_contents_inner_part_17 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_18').insertAfter('.cv_custom_album_play_contents_inner_part_18 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_19').insertAfter('.cv_custom_album_play_contents_inner_part_19 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_20').insertAfter('.cv_custom_album_play_contents_inner_part_20 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_21').insertAfter('.cv_custom_album_play_contents_inner_part_21 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_22').insertAfter('.cv_custom_album_play_contents_inner_part_22 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_23').insertAfter('.cv_custom_album_play_contents_inner_part_23 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_24').insertAfter('.cv_custom_album_play_contents_inner_part_24 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_25').insertAfter('.cv_custom_album_play_contents_inner_part_25 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_26').insertAfter('.cv_custom_album_play_contents_inner_part_26 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_27').insertAfter('.cv_custom_album_play_contents_inner_part_27 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_28').insertAfter('.cv_custom_album_play_contents_inner_part_28 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_29').insertAfter('.cv_custom_album_play_contents_inner_part_29 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_30').insertAfter('.cv_custom_album_play_contents_inner_part_30 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_31').insertAfter('.cv_custom_album_play_contents_inner_part_31 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_32').insertAfter('.cv_custom_album_play_contents_inner_part_32 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_33').insertAfter('.cv_custom_album_play_contents_inner_part_33 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_34').insertAfter('.cv_custom_album_play_contents_inner_part_34 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_35').insertAfter('.cv_custom_album_play_contents_inner_part_35 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_36').insertAfter('.cv_custom_album_play_contents_inner_part_36 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_37').insertAfter('.cv_custom_album_play_contents_inner_part_37 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_38').insertAfter('.cv_custom_album_play_contents_inner_part_38 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_39').insertAfter('.cv_custom_album_play_contents_inner_part_39 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_40').insertAfter('.cv_custom_album_play_contents_inner_part_40 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_41').insertAfter('.cv_custom_album_play_contents_inner_part_41 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_42').insertAfter('.cv_custom_album_play_contents_inner_part_42 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_43').insertAfter('.cv_custom_album_play_contents_inner_part_43 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_44').insertAfter('.cv_custom_album_play_contents_inner_part_44 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_45').insertAfter('.cv_custom_album_play_contents_inner_part_45 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_46').insertAfter('.cv_custom_album_play_contents_inner_part_46 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_47').insertAfter('.cv_custom_album_play_contents_inner_part_47 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_48').insertAfter('.cv_custom_album_play_contents_inner_part_48 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_49').insertAfter('.cv_custom_album_play_contents_inner_part_49 button.plyr__controls__item');
  $('.cv_custom_custom_content_description_50').insertAfter('.cv_custom_album_play_contents_inner_part_50 button.plyr__controls__item');

  $('.cv_custom_download_icon_part').show();
}, 100);
$(document).ready(function(){
  $("audio").bind("play",function (){
    $("audio").not(this).each(function (index, audio) {
      audio.pause();
    });
  });
  $('.plyr__control[data-plyr="download"]').click(function(e){

    e.preventDefault();
    var cv_get_img = $(this).parents('.cv_custom_body_contents_inner_main_part').find('.cv_custom_button_Download_album_image').attr('dara-image-src');
    $('.cv_custom_main_img_download').css("background-image", "url(" + cv_get_img + ")"); 
    $('.cv_custom_download_release').addClass('active');
    $('.cv_login').removeClass('active');
    $('.cv_signup').removeClass('active');
  });
  $('.cv_Custom_main_download_button_download_page').on('click', function (e) {
    var ttt = $('.cv_custom_download_icon_part').each(function() {
      var title =$(this).attr("data-title");
    });
    e.preventDefault();
    var cv_Custom_link = $(this).attr('href');
    var cv_audio_title = $(this).attr('data-audio-title');
    alert(cv_audio_title);
    $.ajax({
      url: cv_Custom_link,
      method: 'GET',
      xhrFields: {
        responseType: 'blob'
      },
      success: function (data) {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = cv_audio_title;
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    });

  });
});
$(document).on('click', '.panel-btn', function(e){
  e.preventDefault();
  var cv_custom_data_img = $(this).attr('data-image');
  var cv_custom_main_title = $(this).attr('data-title');
  var cv_custom_sub_title = $(this).attr('data-mini-title');
  $('.cv_custom_main_Title_download').text(cv_custom_main_title);
  $('.cv_Custom_sub_title_download').text(cv_custom_sub_title);
  $('.cv_custom_main_img_download').css("background-image", "url(" + cv_custom_data_img + ")"); 
  $('.cv_custom_download_release').addClass('active');
  $('.cv_login').removeClass('active');
  $('.cv_signup').removeClass('active');
});
$(document).on('click', '.cv_Custom_login_Release_form, .cv_custom_login_from_here', function(e){
  e.preventDefault();
  $('.cv_login').addClass('active');
  $('.cv_custom_download_release').removeClass('active');
  $('.cv_signup').removeClass('active');
});

$(document).on('click', '.cv_Custom_signup_Release_form, .cv_link_to_Signup, #customer_register_link', function(e){
  e.preventDefault();
  $('.cv_signup').addClass('active');
  $('.cv_login').removeClass('active');
  $('.cv_custom_download_release').removeClass('active');
});

$(document).on('click', '.cv_custom_close_btn_slide', function(e){
  e.preventDefault();
  $('.cv_signup').removeClass('active');
  $('.cv_login').removeClass('active');
  $('.cv_custom_forgot_password').removeClass('active');
  $('.cv_custom_download_release').removeClass('active');
});

$(document).on('mouseover', '.Cv_release_mini_wrap_img', function(){
  $(this).parents('.Cv_release_mini_wrap_inner').find('.cv_custom_main_download_track_button').addClass('cv_custom_hover_download_track_button');

});
$(document).on('mouseout', '.Cv_release_mini_wrap_img', function(){
  $(this).parents('.Cv_release_mini_wrap_inner').find('.cv_custom_main_download_track_button').removeClass('cv_custom_hover_download_track_button');

});

$(document).on('click', '#RecoverPassword', function(e){
  e.preventDefault();
  $('.cv_custom_forgot_password').addClass('active');
  $('.cv_signup').removeClass('active');
  $('.cv_login').removeClass('active');
  $('.cv_custom_download_release').removeClass('active');
});
$(document).on('click', '.cv_custom_button_Download_album_image .icon-download-activated', function(){
  var cv_dynam_img = $('.cv_custom_button_Download_album_image').attr('dara-image-src');
  var cv_audio_sr = $(this).parents('.cv_custom_body_image_contents_album_part').siblings('.cv_custom_album_play_content_part').find('.cv_custom_album_play_contents_inner_part-1').find('audio').find('.cv_audio_src').attr('src');
  $('.cv_Custom_main_download_button_download_page').attr('href',cv_audio_sr);
  $('.cv_custom_main_img_download').css("background-image", "url(" + cv_dynam_img + ")"); 
  $('.cv_login').removeClass('active');
  $('.cv_signup').removeClass('active');
});

$(document).on('click', '.cv_custom_download_icon_part', function(e){
  e.preventDefault();
  var cv_dynam_img = $(this).parents('.cv_custom_album_play_content_part').siblings('.cv_custom_body_image_contents_album_part').find('.cv_custom_button_Download_album_image').attr('dara-image-src');
  var cv_audio_src = $(this).attr('data-audio-src');
  var cv_audio_title = $(this).attr('data-audio-title');
  
  var MusicTitle = $(this).parents('.cv_custom_album_play_contents_inner_part').children('.cv__outer_audio').children('div').children('.plyr__controls').children('.cv_custom_custom_content_description').children('h4').html();
  MusicTitle = MusicTitle.substr(MusicTitle.indexOf(".") + 1)
  MusicTitle = $.trim(MusicTitle);
  var MusicArtist = $(this).parents('.cv_custom_album_play_contents_inner_part').children('.cv__outer_audio').children('div').children('.plyr__controls').children('.cv_custom_custom_content_description').children('p').html();
  MusicArtist = $.trim(MusicArtist); 
  $('.cv_custom_download_release').children('.cv_custom_download_form_inner').children('.cv_custom_main_Title_download').html(MusicTitle);
  $('.cv_custom_download_release').children('.cv_custom_download_form_inner').children('.cv_Custom_sub_title_download').html(MusicArtist);
  $('.cv_custom_download_release').children('.cv_custom_main_img_download').children('.cv_custom_main_img').css('background-image', 'url('+cv_dynam_img+')');
  $('.cv_Custom_main_download_button_download_page').attr('href',cv_audio_src);
  $('.cv_Custom_main_download_button_download_page').attr('data-audio-title',cv_audio_title);
  $('.track-infos').html(`${document.getElementById('artistLabel').textContent} - ${cv_audio_title.split('.')[0].substr(2).split(`_`).join(` `)} `);
  $('.cv_custom_main_img_download').css("background-image", "url(" + cv_dynam_img + ")"); 
  $('.cv_custom_download_release').addClass('active');
  $('.cv_login').removeClass('active'); 
  $('.cv_signup').removeClass('active');   
});
function copyToClipboard(element) { 
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $('.cv_copy_paragraph').addClass('tlite-visible');
  setTimeout(function(){ 
    $('.cv_copy_paragraph').removeClass('tlite-visible');
  }, 3000);
  $temp.remove();
}
$(document).click(function (e) {
  if (!$(e.target).closest('.cv_custom_download_release, .cv_custom_download_icon_part').length) {
    $('.cart_drawer').removeClass('active');
  }
});

$(document).on('click', '.cv_Custom_left_Arrows_fan', function(e){
  e.preventDefault();
  $('.slick-prev').trigger('click');
});
$(document).on('click', '.cv_Custom_right_Arrows_fan', function(e){
  e.preventDefault();
  $('.slick-next').trigger('click');
});

$(document).on('click', '.cv_custom_add_to_Cart', function(e){
  e.preventDefault();
  var thisbtn = $(this).find('.btn__text');

  var varID = $(this).parents('.product-single__form').serialize();
  $.ajax({
    url:'/cart/add',
    type:'POST',
    dataType: 'HTML',
    data: varID,
    success: function(response){
      $('.cv_cart-link__bubble').html($(response).find('.cv_cart-link__bubble').html());
      $('.cv_custom_when_product_cart').show();
      $(thisbtn).text('added');
      setTimeout(function(){
        $(thisbtn).text('ADD TO CART');
        $('.cv_custom_when_product_cart').hide();
      },2000);
    }  
  });
});

$(document).on('click', '.spf-product__form-btn-addtocart', function(e){
  e.preventDefault();
  var thisbtn = $(this).find('.btn__text');
  var varID = $(this).parents('.spf-product__form').serialize();
  $.ajax({
    url:'/cart/add',
    type:'POST',
    dataType: 'HTML',
    data: varID,
    success: function(response){
      $('.cv_cart-link__bubble').html($(response).find('.cv_cart-link__bubble').html());
      $('.cv_custom_when_product_cart').show();
      $(thisbtn).text('added');
      setTimeout(function(){
        $(thisbtn).text('ADD TO CART');
        $('.cv_custom_when_product_cart').hide(); 
      },2000);
    }  
  });
});
$(document).on('click', '.releaseFilter .select-items div', function(){
  var selectedCountry = $(this).text();
  $(this).parents('.cv_custom_outer_select_content_part').find('.cv_custom_all_release_years_outer_content').addClass('cv__select-hide');
  var cv_custom_selected_date = $('select#cv_custom_release_dates').children("option:selected").val();
  $('.Cv_release_mini_wrap').each(function(){
    var cv_custom_release_val = $(this).attr('data-select-art-title');
    var cv_custom_release_Date_val = $(this).attr('data-select-release-yr');
    if(selectedCountry == cv_custom_release_val || cv_custom_release_val == selectedCountry && cv_custom_selected_date == cv_custom_release_Date_val){
      $(this).addClass('cv_Custom_show_release_latest');
      $(this).removeClass('cv_Custom_hide_release_latest');
      $(this).siblings('.Cv_release_mini_wrap').removeClass('cv_Custom_show_release_latest');
      // $(this).siblings('.Cv_release_mini_wrap').addClass('cv_Custom_hide_release_latest');
    }else if(selectedCountry == 'Latest Releases'){
      $(this).removeClass('cv_Custom_hide_release_latest');
      $(this).siblings('.Cv_release_mini_wrap').removeClass('cv_Custom_hide_release_latest');
      location.reload();
    }else{
      $(this).addClass('cv_Custom_hide_release_latest');
      // $(this).removeClass('cv_Custom_show_release_latest');
      // $(this).siblings('.Cv_release_mini_wrap').removeClass('cv_Custom_show_release_latest');
      $(this).siblings('.Cv_release_mini_wrap').addClass('cv_Custom_hide_release_latest');
    }
  }); 
});

// $(document).on('click', '.cv_Custom_release_year_Select .cv_select-items div', function(){
//   var selectdate = $(this).text();
//   //    console.log(selectdate);
//   $(this).parents('.cv_custom_latest_filter_content').siblings('.cv_custom_latest_filter_content').find('.select-items').addClass('cv__select-hide');
//   var cv_custom_selected_artist = $('.cv_custom_select_inner_Select').children("option:selected").val(); 

//   $('.Cv_release_mini_wrap').each(function(){
//     var cv_custom_release_Date_val = $(this).attr('data-select-release-yr');
//     //     console.log(cv_custom_release_Date_val);
//     console.log('yesy' +cv_custom_release_Date_val)
//     var cv_custom_release_Art_val = $(this).attr('data-select-art-title');
//     //     if(selectdate == cv_custom_release_Date_val || cv_custom_release_Date_val == selectdate && cv_custom_selected_artist == cv_custom_release_Art_val ){
//     if(selectdate.indexOf(cv_custom_release_Date_val) > -1 ){
//       //    $(this).addClass('cv_Custom_show_release_latest');

//       //       $(this).removeClass('cv_Custom_hide_release_latest');
//       //       $(this).siblings('.Cv_release_mini_wrap').removeClass('cv_Custom_show_release_latest');
//       // $(this).siblings('.Cv_release_mini_wrap').addClass('cv_Custom_hide_release_latest');

//       //////////////////////////////////////////////
//       $(this).addClass('cv_Custom_show_release_latest');
//       $(this).removeClass('hide')
//       console.log(cv_custom_release_Date_val)


//       /////////////////////////////////
//     }else if(selectdate == 'All'){
//       //       $(this).removeClass('cv_Custom_hide_release_latest');
//       $(this).siblings('.Cv_release_mini_wrap').removeClass('hide');
//     }else{
//       //       $(this).addClass('cv_Custom_hide_release_latest');
//       // $(this).removeClass('cv_Custom_show_release_latest');
//       // $(this).siblings('.Cv_release_mini_wrap').removeClass('cv_Custom_show_release_latest');
//       //       $(this).siblings('.Cv_release_mini_wrap').addClass('cv_Custom_hide_release_latest');

//       ////////////////////

//       $(this).addClass('hide')
//       //////////////
//     }
//   });
// });

$(document).on('click', '.cv_Custom_release_year_Select .cv_select-items div', function(){
  var selectdate = $(this).text();
  if( selectdate == 'All') {
    window.location.href = '/blogs/releases';
  }
  else{
    window.location.href = '/blogs/releases/tagged/releaseYear_'+selectdate;
  }
})


$(document).on("keyup", '.cv_custom_Search_artist_inner_input', function() {
  $('.cv_custom_sort_by_for_only').hide();
  $('.cv_custom_select_by_for_only').show();
  var value = $(this).val().toLowerCase();
  $('.cv_custom_Search_release_btn').attr('data-search-val',value);
  $(".Cv_release_mini_wrap").filter(function() {
    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    var cv_val = $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
  });
});
$(document).on('click', '.cv_custom_redirect_drawer', function(){
  $('.cv_custom_download_release').addClass('active');
  $('.cv_login').removeClass('active');
  $('.cv_signup').removeClass('active');
});
$(window).on('scroll', function() { 
  var scroll = $(window).scrollTop();
  if( $('.cv_custom_product_set_6').length ) {
    if ($(window).scrollTop() >= $('.cv_custom_product_set_6').offset().top + $('.cv_custom_product_set_6').outerHeight() - window.innerHeight) { 
      $('.cv_custom_faq_usase_policy_main_outer_Content_start').addClass('cv_Custom_Sticky_pro_after');
    }else{
      $('.cv_custom_faq_usase_policy_main_outer_Content_start').removeClass('cv_Custom_Sticky_pro_after');
    }
  }
});
$(document).on('mouseover', '.cv_custom_index_music_image_text_contents', function(){
  $(this).find('.cv_custom_index_music_content_btn').css("background-color", "transparent");

});
$(document).on('mouseout', '.cv_custom_index_music_image_text_contents', function(){
  $(this).find('.cv_custom_index_music_content_btn').css("background-color", "transparent");

});
$(document).ready(function(){
  setTimeout(function(){
    $('.cv_Custom_grid_item_Colleciton_products2').slick({
      slidesToShow: 5,
      slidesToScroll: 1,

      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            dots: true,
            slidesToScroll: 2
          }
        }
      ]
    });
  },1000);
});

$(document).ready(function(){
  $('.btn-deactivated-download').click(function(e){
    e.preventDefault();
    $('.cv_custom_download_release').addClass('active');
  });
  $('.icon-download-deactivated').click(function(e){
    e.preventDefault();
    $('.cv_custom_download_release').addClass('active');
  });
});

$(document).ready(function(){
  if ( $('.announcement-bar').length ){
    $('body').addClass('active-announcement');
  }
  setInterval(function(){
    var height = $('.announcement-bar').outerHeight();
    $('.site-header').css('top',height);

  },200);
});

$(document).ready(function(){
  $( ".cv-btn2" ).click(function(e) {
    var id = $(this).attr("data-value");
    event.preventDefault();
    $.ajax({  
      type: "post",
      url: '/cart/add',
      data: {
        id: id, 
        quantity: 1
      },
      success: function(response){
      }
    });
  });  
});

$(document).ready(function(){
  $('.cv-wrap-product').addClass('active');
});